var map = {
	"./bandcamp.svg": 183,
	"./github.svg": 100,
	"./instagram.svg": 739,
	"./soundcloud.svg": 569,
	"./tiktok.svg": 59,
	"./twitch.svg": 228,
	"./youtube.svg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 519;